// extracted by mini-css-extract-plugin
module.exports = {"swiper":"styles-styles-module--swiper--1NI9t","native":"styles-styles-module--native--1mfOL"};